//region :: Imports ::
import {ComponentType} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import WithRouterProps from './WithRouterProps';

//endregion

/** */
const withRouter = <P extends object>(Component: ComponentType<P>) => {

    return (props: Omit<P, keyof WithRouterProps>) => {

        const location = useLocation();
        const navigate = useNavigate();
        const match = {params: useParams()};

        const history = {
            location,
            push: (url: string, state?: any) => navigate(url, {state}),
            back: () => navigate(-1),
            goBack: () => navigate(-1),
            replace: (url: string, state?: any) => navigate(url, {replace: true, state})
        };

        return (
            <Component history={history} location={location} navigate={navigate} match={match}        {...props as P}/>
        );

    };

};

export default withRouter;
